import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
        'Content-Type': 'application/json'
    }
});

export const getData = async (endpoint) => {
    try {
        const response = await api.get(endpoint);
        return response.data;
    } catch (error) {
        console.error('Error get data', error);
        throw error;
    }
};

export const postData = async (endpoint, data, options) => {
    try {
        const response = await api.post(endpoint, data, options);
        return response.data;
    } catch (error) {
        console.error('Error post data', error);
        throw error;
    }
};

export const putData = async (endpoint, data) => {
    try {
        const response = await api.put(endpoint, data);
        return response.data;
    } catch (error) {
        console.error('Error put data', error);
        throw error;
    }
};

export const deleteData = async (endpoint, data) => {
    try {
        const response = await api.delete(endpoint, data);
        return response.data;
    } catch (error) {
        console.error('Error delete data', error);
        throw error;
    }
};

export const getUser = () => {
    return localStorage.getItem('user');
}

export const logout = () => {
    setAuthorizationToken();
    checkToken();
}

export const setAuthorizationToken = (token) => {
    if (token) {
        localStorage.setItem('authToken', token);
        api.defaults.headers['Authorization'] = `Bearer ${token}`;
    } else {
        localStorage.removeItem('authToken');
        delete api.defaults.headers['Authorization'];
    }
};

export const checkToken = () => {
    const token = localStorage.getItem('authToken');

    if (token) {
        try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            const currentTime = Math.floor(Date.now() / 1000);

            if (payload.exp < currentTime) {
                // Token has expired
                console.log('Token expired');
                // Handle token refresh or logout
                // For example: redirect to login or clear token
                localStorage.removeItem('authToken');
                // Optionally, redirect to login page
                window.location.href = '#/auth/login';
            } else {
                console.log('Token is valid');
                // Token is valid, proceed with authenticated actions
                setAuthorizationToken(token)
            }
        } catch (error) {
            console.error('Error decoding token:', error);
            // Handle errors (e.g., token is malformed)
            localStorage.removeItem('authToken');
            setAuthorizationToken()
            // Optionally, redirect to login page
            window.location.href = '#/auth/login';
        }
    } else {
        console.log('No token found');
        // Handle no token scenario (e.g., redirect to login)
        window.location.href = '#/auth/login';
    }
};
